import { Link } from 'react-router-dom';

const managedDomains = [
  {
    title: 'Infrastructure Operations',
    image: 'p2.jpeg',
    description: 'Servers, storage, virtualization, and data center environments.'
  },
  {
    title: 'Network Operations',
    image: 'p3.jpg',
    description: 'LAN/WAN, SD-WAN, wireless, and security appliances with continual optimization.'
  },
  {
    title: 'Security Operations',
    image: 'p4.jpg',
    description: 'Threat monitoring, incident response, and compliance-driven reporting.'
  },
  {
    title: 'Cloud & Applications',
    image: 'p6.jpg',
    description: 'Cloud platform management, database administration, and middleware support.'
  }
];

const ManagedServices = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>Remotely Managed Services</h1>
          <p>
            Nexus IT delivers proactive managed services that safeguard uptime, optimize performance, and provide
            continuous improvement across your technology landscape.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container split">
          <div className="text-block">
            <span className="badge">Our Managed Model</span>
            <h2>Proactive, SLA-Driven Operations</h2>
            <p>
              We assume day-to-day responsibility for your critical systems, combining monitoring, automation, and
              expert support. Our teams operate on ITIL-aligned processes to deliver predictable service levels and fast
              incident resolution.
            </p>
            <ul className="checklist">
              <li>24/7 monitoring and incident management</li>
              <li>Change management with governance controls</li>
              <li>Capacity planning and continuous optimization</li>
              <li>Comprehensive reporting and stakeholder reviews</li>
            </ul>
          </div>
          <div className="service-card">
            <h3>Flexible Engagements</h3>
            <ul>
              <li>Remote, onsite, or hybrid support models</li>
              <li>Custom SLAs aligned with business criticality</li>
              <li>Dedicated or shared service delivery teams</li>
              <li>Integration with existing tools and workflows</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="section-header">
            <span className="tagline">Service Coverage</span>
            <h2 className="section-title">Managed Domains</h2>
          </div>
          <div className="service-grid">
            {managedDomains.map((domain) => (
              <article className="service-card" key={domain.title}>
                <div style={{position: 'relative', borderRadius: '5px', overflow: 'hidden', marginBottom: '1.5rem'}}>
                  <img 
                    src={`/Pictures/${domain.image}`} 
                    alt={domain.title}
                    style={{
                      width: '100%',
                      height: '200px',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                  />
                </div>
                <h3>{domain.title}</h3>
                <p>{domain.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Focus on Your Core Business</h2>
              <p>Delegate the complexity of IT operations to Nexus IT and ensure resilient, secure services.</p>
            </div>
            <Link className="btn btn-primary" to="/contact">
              Request Managed Services
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ManagedServices;
